import { FeatureSectionType, Testimonial } from "../../components/types";

export const getFeatureSections = (
  isDesktop: boolean,
): FeatureSectionType[] => {
  return [
    {
      src: "/landing_page_assets/rive/15.riv",
      fallbackSrc:
        "/landing_page_assets/payor_network_page/featureSection1.png",
      title: "Verse can fulfill orders across all DME categories",
      description: [
        "Verse is able to manage the delivery of nearly every product within the DME category.",
      ],
      className: "min440:tw-flex-row-reverse",
      features: [],
      hasButton: isDesktop,
      imageClassName: "tw-w-full tw-h-full",
      buttonText: "Book a demo",
    },
    {
      src: "/landing_page_assets/rive/16.riv",
      fallbackSrc:
        "/landing_page_assets/payor_case_management_page/doctor1.png",
      title: "Never chase another signature",
      description: [
        "Initiate referrals for clinician signature and let Verse manage the signature collection process end-to-end.",
      ],
      features: [],
      hasButton: isDesktop,
      imageClassName: "tw-w-full tw-h-full",
      buttonText: "Book a demo",
    },
    {
      src: "/landing_page_assets/rive/28.riv",
      fallbackSrc:
        "/landing_page_assets/payor_case_management_page/doctor2.png",
      title: "Manage non-covered & LTSS item procurement in the same place",
      description: [
        "Some members need products beyond what's on the DME fee schedule. Verse optionally enables procurement of non-covered & LTSS products alongside traditional DME.",
      ],
      className: "min440:tw-flex-row-reverse",
      features: [],
      hasButton: isDesktop,
      buttonText: "Book a demo",
    },
    {
      src: "",
      fallbackSrc: "/landing_page_assets/payor_case_management_page/table2.png",
      title: "Verse fits into your case management workflow for DME",
      description: [
        "Every case management team approaches DME coordination differently.",
        "Verse can work with your case management model on day 1.",
      ],
      features: [],
      hasButton: isDesktop,
      buttonText: "Book a demo",
    },
  ];
};

export const testimonials: Testimonial[] = [
  {
    text: "The fact that you can see order status and tracking number without doing too much digging is a big win.",
    author: "Case Manager",
    role: "Midwest Health Plan",
    bgColor: "tw-bg-blue-2",
    textColor: "tw-text-white",
  },
  {
    text: "This is a great system. It's super user friendly and the chat function is cool - folks here really like that.",
    author: "Case Manager",
    role: "Mid-Atlantic Health Plan",
    bgColor: "tw-bg-[#CCEBFF]",
    textColor: "tw-text-black",
  },
  {
    text: "Thank you for all that you have done and continue to do, we really appreciate working with the Verse team.",
    author: "Case Manager",
    role: "Southwest Health Plan",
    bgColor: "tw-bg-[#005C99]",
    textColor: "tw-text-white",
  },
  {
    text: "I don't know why every referring provider wouldn't use this.",
    author: "Case Manager",
    role: "Southeast Health Plan",
    bgColor: "tw-bg-[#003D66]",
    textColor: "tw-text-white",
  },
];
